import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ClanStatsHeader from '../ClanStatsHeader/ClanStatsHeader.js';
import ClanStatsDetails from '../ClanStatsDetails/ClanStatsDetails.js';
import ClanMemberTable from '../ClanMemberTable/ClanMemberTable.js';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs.js';
import { getClanStats } from '../../client/api/server_api.js';
import { useParamsState } from '../../metadata/hooks.js';

const STRINGS = {
    CLAN_NOT_FOUND: gettext("Regiment Not Found"),
    CLAN_NO_PVP: gettext("Must have at least 1 multiplayer battle to be ranked."),
}

function ClanStats() {
    const [clanStats, setClanStats] = useState([]);
    const { clan_db_id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPeriod, setSelectedPeriod] = useParamsState('period', 'lt');

    useEffect(() => {
        window.scrollTo(0,0);
        Promise.all([getClanStats(clan_db_id)])
            .then(results => {
                setClanStats(results[0].data);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [clan_db_id]);

    return (
        <>
            <Breadcrumbs name={ clanStats?.clanDetails?.name }/>
            {isLoading || clanStats?.clanData ? 
                <>
                    <ClanStatsHeader clanDetails={ clanStats?.clanDetails }/>
                    <ClanStatsDetails clanData={ clanStats?.clanData } selectedPeriod={ selectedPeriod } setSelectedPeriod={ setSelectedPeriod }/>
                    { clanStats?.clanDetails?.status === 'active' ? 
                        <ClanMemberTable clanMembers={ clanStats?.clanDetails?.members } selectedPeriod={selectedPeriod}/>
                        : null
                    }
                </> : clanStats?.clanDetails ?
                <>
                    <h2>{STRINGS.CLAN_NO_PVP}</h2>
                </> :
                <>
                    <h1>{STRINGS.CLAN_NOT_FOUND}</h1>
                </>
            }
        </>
    )
}

export default ClanStats;
